import { FC, TextareaHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import classNames from 'classnames';

import classes from './textarea.module.css';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  className?: string;
  register: UseFormRegisterReturn<string>; // react-hook-forms register
  isError?: boolean;
}

export const TextArea: FC<TextAreaProps> = ({
  id, className, register, isError = false, ...rest
}) => {
  const defaultClassName = isError
    ? classNames(classes.textAreaError, classes.textArea) : classes.textArea;

  return (
    <textarea
      id={id}
      className={className || defaultClassName}
      {...register}
      {...rest}
    />
  );
};
